// extracted by mini-css-extract-plugin
module.exports = {"SendMessage":"SendMessage_SendMessage__2ePk8"};